// Tiny module-scoped holder for the current auth user so the BugTracker SDK
// (initialized once in main.jsx before React mounts) can read fresh user
// context on every event. AuthContext calls setBugtrackerUser() whenever
// the user state changes.

let currentUser = null;

export function setBugtrackerUser(user) {
  currentUser = user || null;
}

export function getBugtrackerUser() {
  return currentUser;
}
